import { render, staticRenderFns } from "./FieldModsTable.vue?vue&type=template&id=a0380404"
import script from "./FieldModsTable.vue?vue&type=script&lang=js"
export * from "./FieldModsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports